import { PriceLabel } from 'components';
import React from 'react';
import { numberWithCommas } from 'utility';

const columns = (actionsList, SeeDetailBtn , currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه حساب',
    field: 'id',
    filtering: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'عنوان حساب کسب‌وکاری',
    field: 'name',
    filtering: false,
    align: 'center',
  },
  {
    title: `مجموع درآمد (${currencyText})`,
    field: 'income',
    align: 'center',
    filtering: false,
    render: (rd) => (rd?.income != null ? <PriceLabel amount={rd?.income} /> : '-'),
  },
  ...((actionsList['guildsIncomeDetailFinancialBtn']) ? [{
    title: 'عملیات',
    field: 'details',
    filtering: false,
    align: 'center',
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) =>
      <SeeDetailBtn
        id={rowData?.id}
        startDate={rowData?.startDate}
        endDate={rowData?.endDate}
      />,
  }] : []),
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row?.cols?.[0],
      name: row?.cols?.[1],
      income: row?.cols?.[2],
      startDate: query?.startDate,
      endDate: query?.endDate,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
